import { render, staticRenderFns } from "./YHCard.vue?vue&type=template&id=4b702e45&"
import script from "./YHCard.vue?vue&type=script&lang=js&"
export * from "./YHCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/test-e-youhuo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b702e45')) {
      api.createRecord('4b702e45', component.options)
    } else {
      api.reload('4b702e45', component.options)
    }
    module.hot.accept("./YHCard.vue?vue&type=template&id=4b702e45&", function () {
      api.rerender('4b702e45', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home/YHCard.vue"
export default component.exports